/**
 * Structured logger. Enabled by appending ?ndbg to any page URL.
 *
 * Usage:
 *   import logger from './debug.js';
 *   const log = logger.for('consent');
 *   log.info('TCF resolved', { gdprApplies: true });
 */

const enabled = new URLSearchParams(window.location.search).has('ndbg');
const noop = () => {};

function forModule(module) {
  if (!enabled) return { debug: noop, info: noop, warn: noop, error: noop };
  const tag = `[nd:${module}]`;
  return {
    debug: (msg, ...args) => console.debug(tag, msg, ...args),
    info:  (msg, ...args) => console.info(tag, msg, ...args),
    warn:  (msg, ...args) => console.warn(tag, msg, ...args),
    error: (msg, ...args) => console.error(tag, msg, ...args),
  };
}

export default { for: forModule, enabled };
